export default {
    actionUndo: {
        message: "Ha tévedésből kattintott, kattintson az alábbi linkre a visszaállításhoz.",
        undo: "Kattintson a visszavonáshoz"
    }
}